import React from "react";
import { ConsolidationReportCard } from "./ConsolidationReportCard";
import { ConsolidationReportUIProvider } from "./ConsolidationReportUIContext";

export function ConsolidationReportPage({ history, match }) {
  const consolidationReportUIEvents = {
    newConsolidationReportButtonClick: () => {
      history.push("/admin/consolidationReport/new");
    },
    openEditConsolidationReportPage: id => {
      history.push(`/admin/consolidationReport/${id}/detail`);
    },
    openConsolidationReportFilePage: id => {
      history.push(`/admin/consolidationReport/file/${id}`);
    }
  };

  return (
    <ConsolidationReportUIProvider
      consolidationReportUIEvents={consolidationReportUIEvents}
    >
      <ConsolidationReportCard history={history} match={match} />
    </ConsolidationReportUIProvider>
  );
}
